import React from 'react'
import { BsFacebook, BsTwitter, BsGoogle, BsInstagram, BsLinkedin, BsGithub } from "react-icons/bs";
import { Link } from 'react-router-dom';
import Logo from './logo/Logo';

function Footer() {
    return (
        <>
            {/* Contact CTA */}
			<div id="contact-cta" className="section">

                {/* Backgound Image */}
                <div className="bg-image bg-parallax overlay bg-contact"></div>
                {/* Backgound Image */}

                {/* container */}
                <div className="container">

                    {/* row */}
                    <div className="row">

                        <div className="col-md-8 col-md-offset-2 text-center">
                            <h2 className="white-text">Contact Us</h2>
                            <div>
                                <label className='contact-link'> &#9742;</label>
                                <a href="tel:917989539705" className='contact-link' > &nbsp; +91 7989539705 / </a>
                                <a href="tel:917989539705" className='contact-link' > &nbsp; 040 48502351</a>
                            </div>
                            <a className="main-button icon-button" href="#">Contact Us Now</a>
                        </div>

                    </div>
                    {/* /row */}

                    {/* Footer */}
                    <footer id="footer" className="section">
                                {/* container */}
                                <div className="container">
                                    {/* row */}
                                    <div id="bottom-footer" className="row">

                                        {/* social */}
                                        <div className="col-md-4 col-md-push-8">
                                            <ul className="footer-social">
                                                <li><a target='_blank' href="https://www.youtube.com/@vkctrainings" className="youtube"><i className="fa fa-youtube"></i></a></li>
                                                <li><a target='_blank' href="https://www.facebook.com/people/VKC-Trainings/100086553542487/" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                                <li><a target='_blank' href="https://www.instagram.com/krishnatrainer/" className="instagram"><i className="fa fa-instagram"></i></a></li>
                                                <li><a href="#" className="twitter"><i className="fa fa-twitter"></i></a></li>
                                                <li><a href="#" className="google-plus"><i className="fa fa-google-plus"></i></a></li>
                                                <li><a href="#" className="linkedin"><i className="fa fa-linkedin"></i></a></li>
                                            </ul>
                                        </div>
                                        {/* /social */}

                                        {/* copyright */}
                                        <div className="col-md-8 col-md-pull-4">
                                            <div className="footer-copyright">
                                                <span className='contact-link'>&copy; Copyright 2023. All Rights Reserved. </span>
                                            </div>
                                        </div>
                                        {/* /copyright */}

                                    </div>
                                    {/* row */}

                                </div>
                                {/* /container */}

                    </footer>
                    {/* /Footer */}

                </div>
                {/* /container */}

            </div>
            {/* /Contact CTA */}
        </>
    )
}

export default Footer
